import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { createCallbackActionCreator } from '../../Stream/helpers';
export var initializeNetworkBar = createAction("".concat(actionKey, "/INITIALIZE"), function (networkBarData) { return networkBarData; });
export var initialFetch = createAction("".concat(actionKey, "/FETCH_INITIAL"), function () { return ({}); });
export var fetchMoreWatchedGroups = createCallbackActionCreator("".concat(actionKey, "/FETCH_WATCHED_GROUPS"));
export var fetchMoreRecommendedGroups = createCallbackActionCreator("".concat(actionKey, "/FETCH_RECOMMENDED_GROUPS"));
export var togglePinGroup = createAction("".concat(actionKey, "/TOGGLE_PIN"), function (groupId, isPinnedAfter) { return ({
    groupId: groupId,
    isPinnedAfter: isPinnedAfter,
}); });
export var toggleWatchGroup = createAction("".concat(actionKey, "/TOGGLE_WATCH"), function (groupId, isWatchingAfter) { return ({
    groupId: groupId,
    isWatchingAfter: isWatchingAfter,
}); });
export var unrecommendGroup = createAction("".concat(actionKey, "/UNRECOMMEND"), function (groupId) { return ({ groupId: groupId }); });
export var markChannelAsRead = createAction("".concat(actionKey, "/MARK_AS_READ"), function (channel) { return ({ channel: channel }); });
/** change state and update backend */
export var updateNetworkBarSection = createAction("".concat(actionKey, "/TOGGLE_SECTION"), function (section, isFoldedNow) { return ({
    isFoldedNow: isFoldedNow,
    section: section,
}); });
/** change state without updating backend */
export var setNetworkBarSection = createAction("".concat(actionKey, "/SET_SECTION"), function (section, isFoldedNow) { return ({
    isFoldedNow: isFoldedNow,
    section: section,
}); });
//# sourceMappingURL=actions.js.map